import SkeletonBase from "newui/components/Skeleton";

interface FinalEvaluationStepProps {
	rfxId: number;
	rfxSubmissionId?: number;
	isLoading?: boolean;
}

export const FinalEvaluationStep: React.FC<FinalEvaluationStepProps> = ({
	rfxId,
	rfxSubmissionId,
	isLoading = false,
}) => {
	if (isLoading) {
		return (
			<div className="space-y-3">
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
			</div>
		);
	}

	return (
		<div data-testid="final-evaluation-step">
			<p className="text-sm text-gray-500 mb-4">
				Finalise your evaluation scores and select a preferred supplier to proceed to award.
			</p>
			{/* TODO: Render final evaluation summary and award interface when API is available */}
			<div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm">
				Final evaluation summary and preferred supplier selection will appear here.
			</div>
		</div>
	);
};
